import { useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'

import { deleteAllocation, selectAllocationStatus } from 'slices/allocationsSlice'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  workspaceId: number
  allocationId: number | undefined
  onSuccess: () => void
  onCancel: () => void
}

const WorkspaceAllocationDelete = ({ isOpen, workspaceId, allocationId, onSuccess, onCancel }: Props) => {
  const [modalErrorMessage, setModalErrorMessage] = useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = useState(false)
  const dispatch = useDispatch()
  const { isRequesting, errorMessage } = useSelector(selectAllocationStatus, shallowEqual)

  const handleDeleteClick = () => {
    if (allocationId) {
      setSubmitted(true)
      dispatch(deleteAllocation(workspaceId, allocationId))
    }
  }

  useEffect(() => {
    if (!submitted || isRequesting) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else {
      setModalErrorMessage('削除できませんでした。')
    }
    setSubmitted(false)
  }, [submitted, isRequesting, errorMessage, workspaceId, dispatch, onSuccess])

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    setSubmitted(false)
    onCancel()
  }

  return (
    <CustomModal
      isOpen={isOpen}
      title="作業間配賦設定の削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">この作業間配賦設定を本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default WorkspaceAllocationDelete
